import React from 'react';
import configuration from '../../constants/Configuration';
import { connect } from 'react-redux';
import storeManager from '../../store/StoreManager';
import apiServiceUtils from '../utils/ApiServiceUtils';
import platformDetection from '../utils/PlatformDetection';
import properties from '../../constants/Properties';

const LoaderContent = React.createClass({
    render () {
        var visible = 'none';

        if (this.props.showPreloader == true)
            visible = 'block';
        else
            return (<div/>);

        if (configuration.LOAD_LOCAL == true)
            visible = 'none';

        var topBarHeight = 0;

        if (platformDetection.isIOSApp())
            topBarHeight = properties.CLIPART_BUTTON_HEIGHT;

        topBarHeight = topBarHeight + apiServiceUtils.getNoInternetConnectionAlertHeight();

        const wrapperStyle = {
            position: 'absolute',
            background: '#333333',
            opacity: 0.7,
            top: topBarHeight,
            left: 0,
            width: this.props.windowWidth,
            height: this.props.windowHeight,
            display: visible,
            zIndex: 20000
        };

        const size = 48;

        const loaderStyle = {
            position: 'absolute',
            top: this.props.windowHeight / 2 - size / 2,
            left: this.props.windowWidth / 2 - size / 2,
            color: 'white'
        };

        return (
            <div style={wrapperStyle}>
                <i style={loaderStyle} className="fa fa-spinner fa-pulse fa-3x" />
            </div>
        );
    }
});

function mapStateToProps() {
    const state = storeManager.getState();
    const showPreloader = state.menu.showPreloader;

    return {
        showPreloader
    };
}

export const Loader = connect(mapStateToProps)(LoaderContent);



/** WEBPACK FOOTER **
 ** ./src/components/appLoader/Loader.js
 **/